import React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';
import Img from 'gatsby-image';
import * as mystyles from '../styles/Projects.module.scss';
import '../styles/global.scss';

export default function Projects() {
  const data = useStaticQuery(graphql`
        query MyQuery {
            allMarkdownRemark {
                nodes {
                    frontmatter {
                        title
                        stack
                        slug
                        tags
                        thumb {
                            relativePath
                            childImageSharp {
                                fluid {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                }
            }
        }
    `);
  const inputRef = React.useRef();
  const [animStart, setAnimStart] = React.useState(true);
  const [projectList, setProjectList] = React.useState([]);
  const [uniqueTags, setUniqueTags] = React.useState([]);
  const [selectedTag, setSelectedTag] = React.useState('All Work');
  // const scrollHandler = (_) => {
  //   try {
  //     const x = inputRef.current.getBoundingClientRect();
  //     if (x.top < 200 && animStart == false) {
  //       setAnimStart(true);
  //       window.removeEventListener('scroll', (_) => { });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // console.log(data);

  const handleSelectedTag = (tag) => {
    setSelectedTag(tag);
    initProjectList(tag);
  };

  const haveAnimation = () => {
    if (selectedTag == 'All Work')  return Math.random() <= 0;
    return Math.random() <= 0.2;
  };

  const initUniqueTags = () => {
    const unique = data.allMarkdownRemark.nodes.reduce((arr, item) => {
      const x = item['frontmatter'].tags.map((curr) => curr.trim());
      arr = new Set([...arr, ...x]);
      return arr;
    }, []);
    setUniqueTags([...unique]);
  };

  const initProjectList = (tagSelected) => {
    let arr = [];
    if (tagSelected == 'All Work') arr = data.allMarkdownRemark.nodes;
    else {
      arr = data.allMarkdownRemark.nodes.filter((item, idx) => {
        return item.frontmatter.tags.includes(tagSelected);
      });
    }
    setProjectList(arr);
  };

  React.useEffect(() => {
    // window.addEventListener('scroll', scrollHandler, true);
    initUniqueTags();
    initProjectList(selectedTag);
    // return () => {
    //   window.removeEventListener('scroll', scrollHandler, true);
    // };
  }, []);

  return (
    <div ref={inputRef} className=" relative w-11/12 mx-auto ">
      <div className="absolute -top-24" id="my-projects"></div>
      <div className=" mb-12">
        <div
          className={` text-center uppercase font-bold text-sm tracking-wider text-about-secondary relative heading`}
        >
          My Projects
        </div>
      </div>
      {/* Tabs */}
      <ul className="flex flex-row it px-0 flex-wrap uppercase text-sm font-semibold text-gray-500 md:px-8">
        <li
          className={` mx-1 my-4 cursor-pointer ${selectedTag == 'All Work' ? ' text-about-primary' : ''
            } `}
        >
          <span
            className="px-4 py-1"
            onClick={(_) => handleSelectedTag('All Work')}
          >
            All Work
          </span>
        </li>
        {uniqueTags.map((item, idx) => {
          return (
            <li
              key={idx}
              className={`mx-1 my-4 cursor-pointer ${selectedTag == item ? ' text-about-primary' : ''
                }`}
            >
              <span
                className="px-4 py-1"
                onClick={(_) => handleSelectedTag(item)}
              >
                {item}
              </span>
            </li>
          );
        })}
      </ul>
      {/* Gallary */}
      <div className=" mt-6 flex flex-row flex-wrap pb-12">
        {[...Array(4)].map((x, i) => (
          <div key={i} className=" w-11/12 md:max-w-1/2 lg:max-w-1/4">
            {projectList.map((item, idx) => {
              if (idx % 4 !== i) return null;
              return (
                <>
                  <div
                    key={idx}
                    className={`w-full mx-3 mb-6 min-h-48 bg-indigo-300 relative ${mystyles.card
                      } md:w-4/5 md:mx-auto xl:w-11/12
                                                    ${!haveAnimation() ?
                        '' :
                        i == 0 &&
                          idx < 3 &&
                          projectList.length <
                          4 ?
                          ` -right-full z-40 ${animStart ?
                            mystyles.animLeft100 :
                            ''
                          }` :
                          i == 0 &&
                            idx <= 3 &&
                            projectList.length >=
                            4 ?
                            ` -bottom-48 ${animStart ?
                              mystyles.animTop100 :
                              ''
                            }` :
                            i == 0 && idx > 3 ?
                              ` -top-48 z-10 ${animStart ?
                                mystyles.animDown100 :
                                ''
                              }` :
                              i == 1 &&
                                idx < 3 &&
                                projectList.length <
                                4 ?
                                ` -left-full z-20 ${animStart ?
                                  mystyles.animRight100 :
                                  ''
                                }` :
                                i == 1 && idx <= 3 ?
                                  ` -left-full z-20 ${animStart ?
                                    mystyles.animRight100 :
                                    ''
                                  }` :
                                  i == 1 && idx > 3 ?
                                    ` -right-full-2x z-30 ${animStart ?
                                      mystyles.animLeft200 :
                                      ''
                                    }` :
                                    i == 2 && idx <= 3 ?
                                      ` -left-full z-20 ${animStart ?
                                        mystyles.animRight100 :
                                        ''
                                      }` :
                                      i == 2 && idx > 3 ?
                                        ` -right-full z-40 ${animStart ?
                                          mystyles.animLeft100 :
                                          ''
                                        }` :
                                        i == 3 ?
                                          ` -left-full-2x z-50 ${animStart ?
                                            mystyles.animRight200 :
                                            ''
                                          }` :
                                          ''
                      }
                                                `}
                  >
                    <Link
                      to={
                        '/projects/' +
                        item.frontmatter.slug
                      }
                    >
                      <Img
                        className="w-full object-cover static"
                        fluid={
                          item.frontmatter.thumb
                            .childImageSharp.fluid
                        }
                      />
                    </Link>
                    <div
                      className={`min-w-0 absolute overflow-hidden bottom-0 left-5 right-5 opacity-0 rounded-lg z-10 py-5 px-7 transition-all ease-in-out delay-0 duration-500 lg:p-3 lg:left-3 lg:right-3 xl:left-5 xl:right-5 xl:px-7 xl:py-5`}
                    >
                      <p className=" text-sm tracking-wide font-bold uppercase mb-2 leading-relaxed text-gray-800 text-opacity-80">
                        {item.frontmatter.tags.join(
                          ', ',
                        )}
                      </p>
                      <h4 className=" font-bold text-xl tracking-tight text-gray-700">
                        <Link
                          to={
                            '/projects/' +
                            item.frontmatter.slug
                          }
                        >
                          {item.frontmatter.title}
                        </Link>
                      </h4>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
